import { authenticatedFetch, backendUrl } from "@/data/http"
import type { ShippingAddressApiDto } from "@/model/ShippingAddress"
import type { PatientAppStateApiDto } from "@/model/PatientAppState"
import type { MedicationApiDto } from "@/model/Medication"

export type PatientProfileApiDto = {
  heightInCentimeters?: number
  weightInKilograms?: number
  numberOfFetuses?: number
  estimatedDateOfDelivery?: string  // ISO LocalDate
  medications?: MedicationApiDto[]
  patientAppState?: PatientAppStateApiDto
}

export const updatePatientProfile = ({
  patientId,
  profile,
}: {
  patientId: string
  profile: PatientProfileApiDto
}) =>
  authenticatedFetch<PatientProfileApiDto>(
    `${backendUrl}/v1/${patientId}/profile`,
    {
      method: "PATCH",
      body: JSON.stringify(profile),
    },
  )

export const updateShippingInfo = ({
  patientId,
  address,
}: {
  patientId: string
  address: ShippingAddressApiDto
}) =>
  authenticatedFetch<ShippingAddressApiDto>(
    `${backendUrl}/v1/patients/${patientId}/shipping-info`,
    {
      method: "PATCH",
      body: JSON.stringify(address),
    },
  )

export const getMedicationReminders = ({ patientId }: { patientId: string }) =>
  authenticatedFetch<string[]>(`${backendUrl}/v1/patients/${patientId}/reminders/medication`)

export const setMedicationReminders = ({
  patientId,
  reminderTimes,
}: {
  patientId: string
  reminderTimes: string[]  // "HH:mm" format
}) =>
  authenticatedFetch<void>(
    `${backendUrl}/v1/patients/${patientId}/reminders/medication`,
    {
      method: "PUT",
      body: JSON.stringify(reminderTimes),
    },
  )
